import PropTypes from 'prop-types';

export const ProductPropType = {
  name: PropTypes.string,
  price: PropTypes.number,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  imageUrl: PropTypes.string,
};
